import { render } from "./FinancialAccountDetailSummaryTab.vue?vue&type=template&id=83a129d0&scoped=true"
import script from "./FinancialAccountDetailSummaryTab.vue?vue&type=script&lang=js"
export * from "./FinancialAccountDetailSummaryTab.vue?vue&type=script&lang=js"

import "./FinancialAccountDetailSummaryTab.vue?vue&type=style&index=0&id=83a129d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a129d0"]])

export default __exports__